import { render, staticRenderFns } from "./DailyStat.vue?vue&type=template&id=b709b848&"
import script from "./DailyStat.vue?vue&type=script&lang=js&"
export * from "./DailyStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports